import { render, staticRenderFns } from "./CreateFlatModal.vue?vue&type=template&id=5bb761af&"
import script from "./CreateFlatModal.vue?vue&type=script&lang=js&"
export * from "./CreateFlatModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports